import { render, staticRenderFns } from "./CompositeModal.htm?vue&type=template&id=3db6e081&scoped=true&"
import script from "./CompositeModal.ts?vue&type=script&lang=js&"
export * from "./CompositeModal.ts?vue&type=script&lang=js&"
import style0 from "./CompositeModal.scss?vue&type=style&index=0&id=3db6e081&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db6e081",
  null
  
)

export default component.exports